import { Typography } from '@psl/components/typography';
import { createContext, memo, ReactNode, useContext, useMemo } from 'react';

export type FontConfigContextProps = {
  responsiveClass?: Typography.ResponsiveClass;
  config?: Typography.FontConfig;
};

export const FontConfigContext = createContext<
  FontConfigContextProps | undefined
>(undefined);

export const FontConfigProvider = memo(
  ({
    children,
    responsiveClass,
    config,
  }: FontConfigContextProps & {
    children?: ReactNode;
  }) => {
    const context = useContext(FontConfigContext);
    const value = useMemo<FontConfigContextProps>(
      () => ({
        responsiveClass: responsiveClass ?? context?.responsiveClass,
        config: config ?? context?.config,
      }),
      [config, context?.config, context?.responsiveClass, responsiveClass],
    );
    return (
      <FontConfigContext.Provider value={value}>
        {children}
      </FontConfigContext.Provider>
    );
  },
);

export const kDefaultFontConfig: Typography.FontConfig = {
  heading: {
    small: {
      fontSize: 13,
      lineHeight: 18,
      fontWeight: 600,
    },
    medium: {
      fontSize: 16,
      lineHeight: 24,
      fontWeight: 700,
    },
    large: {
      fontSize: 19,
      lineHeight: 28,
      fontWeight: 800,
    },
  },
  body: {
    small: {
      fontSize: 12,
      lineHeight: 14,
    },
    medium: {
      fontSize: 14,
      lineHeight: 18,
    },
    large: { fontSize: 16, lineHeight: 21 },
  },
  button: {
    small: {
      fontSize: 12,
      lineHeight: 14,
      fontWeight: 600,
    },
    medium: {
      fontSize: 14,
      lineHeight: 18,
      fontWeight: 600,
    },
    large: {
      fontSize: 16,
      lineHeight: 22,
      fontWeight: 600,
    },
  },
};
